export default {"src":"/_next/static/media/mobvoi_logo.5461ff46.svg","height":24,"width":86};